import React from "react";
import { AppRouteURI, AppRoutingRoles } from "router/RoleBasedAccess";
import App from "../app/App";
import LandingView from "./LandingView";

export default () => {
  const { isProtected, checkRoles } = {
    ...AppRoutingRoles[AppRouteURI.LANDING],
  };
  return (
    <App isProtected={isProtected} checkRoles={checkRoles} showHeader={false}>
      <LandingView />
    </App>
  );
};
